import { VideoCard } from './VideoCard';

import type { CategoryRow } from '@/lib/queries/browse';

/**
 * One category row: a sans title (§3: weight 500, 0.04em tracking — serif is
 * reserved for the wordmark, hero, article headlines, and the editorial
 * heading) and a 3-up 16:9 grid. An empty category renders nothing. ("See all"
 * row pagination returns with its own increment.)
 */
export function VideoRow({ row }: { row: CategoryRow }) {
  if (row.videos.length === 0) return null;
  return (
    <section>
      <h2 className="font-sans text-sm font-medium uppercase tracking-[0.04em] text-video-text">
        {row.category.name}
      </h2>
      <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {row.videos.slice(0, 3).map((v) => (
          <VideoCard key={v.id} video={v} />
        ))}
      </div>
    </section>
  );
}
